module.exports = __webpack_public_path__ + "img/trading3.7dc3a39b.svg";